module.exports = "//static.hsappstatic.net/HubspotToolsMenu/static-1.66/js/sprocket_orange.svg"


//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-webpack/lib/bender-url-loader.js!./js/sprocket_orange.svg
// module id = 4
// module chunks = 0 1